<template>
    <div class="consultationRecordList">
        <div v-if="list.length">
            <AddBtn name="添加家长咨询" path="/consultant/minestudent/main/consultationRecord/parent/add"></AddBtn>
            <ParentListTable
                :list="list"
                :userType="userType"
                :studentId="studentId"
            ></ParentListTable>
            <Pagination :pageData="pageData" @changePage="changeCurrent"></Pagination>
        </div>
        <Add
            v-else
            path='/consultant/minestudent/main/consultationRecord/
            /add'
            name="暂无家长交流记录，现在"
        />
    </div>
</template>
<script>
import Add from '@/components/consultant/Add.vue'
import AddBtn from '@/components/consultant/AddBtn.vue'
import ParentListTable from '@/components/consultant/consultationRecord/ParentListTable.vue'
import Pagination from '@/components/consultant/Pagination.vue'
export default {
    name: "competitionList",
    components: {
        Add,
        AddBtn,
        ParentListTable,
        Pagination
    },
    data() {
        return {
            userType: 3,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            list: [],
            pageData: {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数数
                total:1//总条数
            }
        }
    },
    computed: {
    },
    created() {
        this.getParentInterviewList(this.studentId,this.pageData);
    },
    methods: {
        changeCurrent(value) {
            this.pageData.current = value;
            this.getParentInterviewList(this.studentId,this.pageData);
        },
        // 获取成绩列表
        getParentInterviewList(studentId,pageData){
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.consultationRecord.getParentInterviewList, {
                studentId: studentId,
                pageSize: pageData.pageSize,
                pageNumber: pageData.current
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let page = res.data.data.page;
                    this.list = res.data.data.list;
                    this.pageData={
                        current:page.pageNumber,//当前页
                        pageSize:page.pageSize,//每页多少条
                        totalPage:page.count,//总页数数
                        total:page.count//总条数
                    };
                }else{

                }
            })
        },
    }

}
</script>

<style scoped lang="less">
.consultationRecordList {
    background-color: #fff;
    padding: 0 20px;
    min-height: 600px;
}
</style>